<template>
    <v-app id="inspire">
        <v-app-bar app color="white" flat>
            <img src="@/assets/logo.png" style="max-height: 60px" />
            <v-tabs centered class="ml-n9" color="grey darken-1">
                <v-tab v-for="link in filter(links)" :key="link.path" :to="link.path">
                    {{ link.name }}
                </v-tab>
            </v-tabs>

            <v-avatar class="hidden-sm-and-down" color="grey darken-1 shrink" size="32"></v-avatar>
        </v-app-bar>

        <v-main class="grey lighten-3">
            <v-container fluid>
                <v-row>
                    <v-col cols="12" sm="12">
                        <v-sheet min-height="90vh" rounded="lg">
                            <router-view />
                        </v-sheet>
                    </v-col>
                </v-row>
            </v-container>
        </v-main>
    </v-app>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
document.title = 'Статистика по цеху ООО "ЗМИ"'
export default {
    data: () => ({
        links: [
            {
                path: '/statistic',
                name: 'Статистика',
                roles: ['all'],
            },
            {
                path: '/accessories',
                name: 'Комплектующие',
                roles: ['admin'],
            },
            {
                path: '/products',
                name: 'Продукты',
                roles: ['admin'],
            },
            {
                path: '/sub_groups',
                name: 'Подгруппы',
                roles: ['admin'],
            },
            {
                path: '/plans',
                name: 'План производства',
                roles: ['admin', 'financier', 'orp', 'user-orp'],
            },
            {
                path: '/set_fact',
                name: 'Фактически произвели',
                roles: ['admin', 'master', 'worker'],
            },
            {
                path: '/brigades',
                name: 'Бригады',
                roles: ['admin', 'master', 'worker'],
            },
            {
                path: '/news',
                name: 'Новости',
                roles: ['admin', 'master'],
            },
            {
                path: '/users',
                name: 'Пользователи',
                roles: ['admin'],
            },

            {
                path: '/archive',
                name: 'Архив',
                roles: ['admin', 'financier', 'master', 'orp', 'user-orp'],
            },
            {
                path: '/rates',
                name: 'Рейтинги',
                roles: ['admin', 'department', 'all_users', 'orp'],
            },
            {
                path: '/login',
                name: 'Войти',
                roles: ['all_auth'],
            },
            {
                path: '/logout',
                name: 'Выйти',
                roles: ['logout'],
            },
        ],
    }),
    computed: {
        ...mapGetters(['get_show_route', 'get_user']),
    },
    methods: {
        ...mapActions(['load_user']),
        check_session() {
            // const limit = 300000; // 5 минут
            const limit = 3600000 * 5 // 1 час * 5
            const localStorageInitTime = localStorage.getItem('localStorageInitTime')

            if (localStorageInitTime === null) {

                // if (this.$route.name === 'statistic') this.$router.push('/')
            } else if (+new Date() - localStorageInitTime > limit) localStorage.clear()
            else {
                this.load_user()
            }
        },
        filter(links) {
            let new_links = []

            if (!localStorage.getItem('title')) {
                links.forEach((link) => {
                    const role = link.roles.find((role) => role == 'all_auth' || role == 'all')
                    if (role) new_links.push(link)
                })
            } else {
                links.forEach((link) => {
                    let role = []

                    if (localStorage.getItem('title') == 'department') {
                        
                        role = link.roles.find(
                            (role) => role == localStorage.getItem('title') || role == 'logout' || role == 'all_users'
                        )
                    } else {
                        role = link.roles.find(
                            (role) => role == localStorage.getItem('title') || role == 'logout' || role == 'all'
                        )
                    }
                    if (role) new_links.push(link)
                })
            }

            return new_links
        },
    },
    beforeMount() {
        this.check_session()
        //Здесь сделать проверку времени localstor
    },
}
</script>
<style>
#app {
    font: 15px/24px 'Open Sans', Arial, sans-serif;
}
</style>
